function baseClient($http) {

  let baseUrl = '';

  return {
    /**
     * @description Sets base url.
     * @param {String} url.
     */
    setBaseUrl: (url) => {

      baseUrl = url;

    },
    /**
     * @description Sends request.
     * @param {Object} request
     * @returns {Object}
     */
    sendRequest: (request) => {

      request.url = baseUrl.concat(request.uri);

      return $http(request);

    }

  };

}

export default baseClient;


// WEBPACK FOOTER //
// ./src/angular-services/base.client.service.js